import {createSelector} from "reselect";
import {getPricingTable} from "../../redux/products/productsDataExtractors";
import {getPriceInfo} from "../../feature/ProductDescriptor/v1/productDescriptorUtils";
import type {ProductDescriptor} from "~/feature/ProductDescriptor/v1/types";

export const getSalesmanPriceTable = createSelector(
  (product: ProductDescriptor, packCode: string) => getPriceInfo({ product, packCode }),
  (priceInfo) => {
    if (!priceInfo) {
      return undefined;
    }

    return getPricingTable(priceInfo);
  },
);

export const isSalesmanPriceTableEmpty = createSelector(getSalesmanPriceTable, (priceTable) => {
  if (!priceTable) {
    return true;
  }
  return priceTable.every((row) => !row.csp && !row.msp && !row.rsp);
});

export const isSpecialPrice = (productDescriptor: ProductDescriptor, packCode: string) => {
  const priceInfo = getPriceInfo({ product: productDescriptor, packCode });
  return priceInfo?.isSpecialPrice ?? false;
};

export const getIsContractAvailable = (product: ProductDescriptor) => {
  return product.prices.length > 0 && product.prices.some((i) => i.isContractAvailable);
};
